import '@babel/polyfill';
import VeeValidate, { Validator } from 'vee-validate';
import Vue from 'vue';
import './plugins/vuetify';
import moment from 'dayjs';
import axios from 'axios';
import plTranslation from 'vee-validate/dist/locale/pl';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './config/toastr.config';
import '../node_modules/bootstrap/scss/bootstrap.scss';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';
import i18n from './config/i18n';
import axiosInstance from './config/axios';
import './styles/globals.scss';
import './directives/checkPermissions';


Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Validator.localize({ pl: plTranslation });
Vue.use(VeeValidate,
  {
    locale: 'pl',
    fieldsBagName: 'veeFields',
  });

if (localStorage.getItem('TOKEN')) {
  axiosInstance.defaults.headers.Authorization = `Bearer ${localStorage.getItem('TOKEN')}`;
  store.commit('AuthStore/setUser', JSON.parse(localStorage.getItem('USERDATA')));
}

new Vue({
  router,
  store,
  axios,
  i18n,
  render: h => h(App),
}).$mount('#app');
